import { type IToastShow } from 'shared/ui'
import { toastStore } from 'shared/ui/Toast/store/toast'

export const showToast = (data: IToastShow): string => {
  return toastStore.add(data)
}
